<template>
  <ContentWrapperControl>
    <div v-if="show.fun_run">
      <div class="bg-white shadow mt-4 overflow-hidden">
        <img :src="getBanner()" />

        <div v-if="new Date(fun_run.registration_end) > new Date()">
          <div class="p-4">
            <SpecialCountdownControl :date="fun_run.registration_end" />
          </div>
        </div>

        <div
          v-else
          class="py-4 text-center text-sm font-semibold text-red-600 leading-normal"
        >
          <span>Registration has ended.</span>
        </div>
      </div>
      <div
        class="bg-white rounded-xl shadow-md mt-4 p-5 flex flex-col items-start text-gray-800 leading-normal"
      >
        <div class="w-full mb-4 flex items-center">
          <p
            class="px-3 py-1 border-l-8 border-warning text-gray-700 font-bold uppercase tracking-wide"
          >
            {{ this.lang("lbl_0000342") }}
          </p>
        </div>
        <div class="flex items-center my-2">
          <img
            class="w-5 h-5 mr-2"
            :src="require('@/assets/icons/papsi_calendar.svg')"
          />
          <p class="text-sm text-gray-700 font-medium">
            {{ formattedDate }}
          </p>
        </div>
        <div class="flex items-center mb-6">
          <img
            class="w-5 h-5 mr-2"
            :src="require('@/assets/icons/papsi_location.svg')"
          />
          <p class="text-sm text-gray-700 font-medium">
            {{ fun_run.event_location || "To be announced" }}
          </p>
        </div>
        <div class="w-full">
          <ButtonControl
            class="w-full"
            :disabled="!fun_run.has_started || fun_run.has_ended"
            @click="$router.push('/fun-run/registration')"
          >
            {{ this.lang("lbl_0000326") }}
          </ButtonControl>
          <ButtonControl
            class="w-full mt-2"
            :disabled="!fun_run.has_started || fun_run.has_ended"
            @click="$router.push('/fun-run/registrants')"
            outline
          >
            {{ this.lang("lbl_0000329") }}
          </ButtonControl>
        </div>
      </div>
    </div>
    <div
      v-if="show.election"
      class="overflow-hidden bg-white rounded-lg shadow mt-4"
    >
      <div class="bg-white p-4 -mt-1 rounded-lg">
        <div class="border-l-4 border-secondary pl-3 flex flex-col mt-3 mb-4">
          <span class="font-semibold text-sm">44th GENERAL ASSEMBLY</span>
          <span class="text-xs">Philippine Army Headquarters, Taguig City</span>
        </div>
        <img :src="getBanner()" class="w-full object-cover rounded-lg my-2" />
        <div
          v-if="
            countdownDate ||
            (!getElectionUser.can_participate &&
              getSchedules.registration_ended)
          "
        >
          <div
            class="uppercase italic font-bold text-primary text-center text-sm mt-3 mb-3"
          >
            {{ countdownLabel }}
          </div>

          <SpecialCountdownControl :date="countdownDate" />
        </div>
        <div
          v-if="!isActionButtonVisible && getSchedules.voting_ended"
          class="line-container"
        >
          <hr />
        </div>
        <div
          v-if="
            getSchedules.registration_ended &&
            !getSchedules.voting_started &&
            !getElectionUser.has_registered
          "
          class="mt-3 text-center text-sm font-semibold text-red-600"
        >
          Registration has ended.
        </div>
        <div
          v-if="getSchedules.voting_ended"
          class="mt-3 text-center text-sm font-semibold text-red-600"
        >
          Voting has ended.
        </div>
        <div class="mt-3">
            <!-- Already voted -->
            <ButtonControl
              v-if="
                getElectionUser.has_participated &&
                getSchedules.voting_started &&
                !getSchedules.voting_ended
              "
              class="w-full"
              :disabled="true"
            >
              {{ lang("lbl_0000375") }}
            </ButtonControl>

            <!-- Vote Now -->
            <ButtonControl
              v-if="
                getElectionUser.has_registered &&
                getElectionUser.can_participate &&
                !getElectionUser.has_participated &&
                getSchedules.voting_started &&
                !getSchedules.voting_ended
              "
              class="w-full"
              @click="$router.push('/ga/policy')"
            >
              {{ lang("lbl_0000121") }}
            </ButtonControl>

            <!-- Already Registered -->
            <ButtonControl
              v-if="
                getElectionUser.has_registered &&
                !(
                  getElectionUser.can_participate && getSchedules.voting_started
                )
              "
              class="w-full"
              disabled
            >
              {{ lang("lbl_0000352") }}
            </ButtonControl>

            <!-- Register -->
            <ButtonControl
              v-else-if="
                getSchedules.registration_started &&
                !getElectionUser.has_registered &&
                !getSchedules.registration_ended
              "
              class="w-full"
              @click="register"
            >
              {{ lang("lbl_0000113") }}
            </ButtonControl>

            <!-- Not yet started -->
            <ButtonControl
              v-else-if="!getSchedules.registration_started"
              class="w-full"
            >
              {{ lang("lbl_0000382") }}
            </ButtonControl>
          </div>
        <div class="mt-3 mb-1 text-center">
          <span
            @click="show.schedules = true"
            class="text-primary underline text-sm"
            >{{ this.lang("lbl_0000355") }}</span
          >
        </div>
      </div>
    </div>
  </ContentWrapperControl>
  <ModalControl
    @closed="show.schedules = false"
    :dismiss="true"
    :show="show.schedules"
    :title="lang('lbl_0000155')"
    theme="success"
  >
    <div class="w-full flex justify-center">
      <div class="py-3 text-center">
        <div class="mb-6">
          <div class="mb-1 text-sm">
            {{ this.lang("lbl_0000356") }}
          </div>
          <div class="text-primary font-semibold">
            {{ this.formatDate(this.getSchedules.registration_start) }}
          </div>
        </div>

        <div class="mb-6">
          <div class="mb-1 text-sm">
            {{ this.lang("lbl_0000357") }}
          </div>
          <div class="text-primary font-semibold">
            {{ this.formatDate(this.getSchedules.registration_end) }}
          </div>
        </div>

        <div class="mb-6">
          <div class="mb-1 text-sm">
            {{ this.lang("lbl_0000358") }}
          </div>
          <div class="text-primary font-semibold">
            {{ this.formatDate(this.getSchedules.voting_start) }}
          </div>
        </div>

        <div>
          <div class="mb-1 text-sm">
            {{ this.lang("lbl_0000359") }}
          </div>
          <div class="text-primary font-semibold">
            {{ this.formatDate(this.getSchedules.voting_end) }}
          </div>
        </div>
      </div>
    </div>
  </ModalControl>
</template>

<script>
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import SpecialCountdownControl from "@/components/controls/SpecialCountdownControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import ModalControl from "@/components/controls/ModalControl.vue";
import parseMobile from "libphonenumber-js";
import FunRun from "@/services/FunRun";
import GA from "@/services/GA";
import mixin from "@/mixin.js";

export default {
  mixins: [mixin],
  emits: [
    "success",
    "error",
    "alert",
    "login",
    "logout",
    "showloader",
    "hideloader",
    "showblinder",
    "hideblinder",
    "terminate",
    "checkauth",
    "nofooter",
    "shownavbar",
    "hidenavbar",
    "opensidebar",
    "closed",
    "agreed",
  ],
  components: {
    ContentWrapperControl,
    SpecialCountdownControl,
    ModalControl,
    ButtonControl,
  },
  data() {
    return {
      username: "",
      password: "",
      mobile: "",
      email: "",
      show: {
        fun_run: false,
        election: true,
        schedules: false,
      },
      fun_run: {
        run_key: null,
        run_year: null,
        event_name: null,
        event_date: null,
        event_location: null,
        has_started: false,
        has_ended: false,
        registration_start: null,
        registration_end: null,
      },
      election: {
        code: this.$store.state.ga.code,
        title: this.$store.state.ga.title,
        date: this.$store.state.ga.date,
        test_user: {
          can_participate: true,
          has_participated: false,
          has_registered: false,
          enabled: false,
        },
        user: {
          can_participate: this.$store.state.ga.user.can_participate,
          has_participated: this.$store.state.ga.user.has_participated,
          has_registered: this.$store.state.ga.user.has_registered,
        },
        schedules: {
          registration_start: this.$store.state.ga.registration.start_date,
          registration_started: this.$store.state.ga.registration.started,
          registration_end: this.$store.state.ga.registration.end_date,
          registration_ended: this.$store.state.ga.registration.ended,
          voting_start: this.$store.state.ga.voting.start_date,
          voting_started: this.$store.state.ga.voting.started,
          voting_end: this.$store.state.ga.voting.end_date,
          voting_ended: this.$store.state.ga.voting.ended,
        },
        test_schedules: {
          registration_start: "2026-02-19 00:00:00",
          registration_started: true,
          registration_end: "2026-02-24 00:00:00",
          registration_ended: false,
          voting_start: "2026-03-20 10:30:00",
          voting_started: false,
          voting_end: "2026-03-03 14:00:00",
          voting_ended: false,
          enabled: false,
        },
      },
    };
  },
  computed: {
    formattedDate() {
      if (!this.fun_run.event_date) return "";
      return new Date(this.fun_run.event_date).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    getElectionUser() {
      const u = this.election.user;
      const t = this.election.test_user;

      if (!t.enabled) return u;

      return {
        can_participate: t.can_participate ?? u.can_participate,
        has_participated: t.has_participated ?? u.has_participated,
        has_registered: t.has_registered ?? u.has_registered,
      };
    },
    countdownDate() {
      const s = this.getSchedules;
      const u = this.getElectionUser;

      if (!s) return null;

      if (
        !u.has_registered &&
        s.registration_started &&
        !s.registration_ended
      ) {
        return s.registration_end;
      }

      if (u.has_registered && u.can_participate) {
        if (!s.voting_started && s.voting_start) return s.voting_start;
        if (s.voting_started && !s.voting_ended) return s.voting_end;
      }

      if (!u.can_participate) {
        if (s.registration_started && !s.registration_ended)
          return s.registration_end;
        if (!s.registration_started && s.registration_start)
          return s.registration_start;
        if (s.registration_ended) return s.registration_end;
      }

      return null;
    },

    countdownLabel() {
      const s = this.getSchedules;
      const u = this.getElectionUser;

      if (!s) return "";

      if (!u.has_registered) {
        if (!s.registration_started) return "Registration starts in";
        if (s.registration_started && !s.registration_ended)
          return "Registration ends in";
        if (s.registration_ended) return "Registration has ended";
      }

      if (u.has_registered && u.can_participate) {
        if (!s.voting_started) return "Voting starts in";
        if (s.voting_started && !s.voting_ended) return "Voting ends in";
        if (s.voting_ended) return "Voting has ended";
      }

      if (!u.can_participate) {
        if (!s.registration_started) return "Registration starts in";
        if (s.registration_started && !s.registration_ended)
          return "Registration ends in";
        if (s.registration_ended) return "Registration has ended";
      }

      return "";
    },
    getSchedules() {
      const s = this.election.schedules;
      const t = this.election.test_schedules;

      if (!t.enabled) return s;

      const reg_start = t.registration_start ?? s.registration_start;
      const reg_end = t.registration_end ?? s.registration_end;
      const vote_start = t.voting_start ?? s.voting_start;
      const vote_end = t.voting_end ?? s.voting_end;

      return {
        registration_start: reg_start,
        registration_end: reg_end,
        voting_start: vote_start,
        voting_end: vote_end,

        registration_started: this.hasStarted(reg_start),
        registration_ended: this.hasEnded(reg_end),

        voting_started: this.hasStarted(vote_start),
        voting_ended: this.hasEnded(vote_end),
      };
    },
    isActionButtonVisible() {
      const u = this.getElectionUser;
      const s = this.getSchedules;

      // Vote Now button
      if (
        u.has_registered &&
        u.can_participate &&
        s.voting_started &&
        !s.voting_ended
      )
        return true;

      // Already Registered button
      if (u.has_registered) return true;

      // Register button
      if (!u.has_registered && !s.registration_ended) return true;

      return false;
    },
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", false);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000336"),
      show: true,
      back: true,
    });

    let state = this.$store.state;
    this.username = state.info.username;
    this.password = state.password;
    this.email = state.info.email;

    if (state.info.mobile_no) {
      let mobile = parseMobile(state.info.mobile_no, "PH")
        .formatNational()
        .split(" ");
      this.mobile = "(" + mobile[0] + ") " + mobile[1] + " " + mobile[2];
    }

    if (this.show.fun_run) {
      this.loadFunRun();
    } else if (this.show.election && !this.$store.state.ga.code) {
      this.loadElection();
    }
  },
  methods: {
    hasStarted(date) {
      if (!date) return false;
      return new Date() >= new Date(date);
    },

    hasEnded(date) {
      if (!date) return false;
      return new Date() >= new Date(date);
    },
    getBanner() {
      let path;
      let file_name;
      if (this.show.fun_run) {
        path = "funrun/";
        file_name = "papsi_run_header.jpg";
      } else if (this.show.election) {
        path = "ga/";
        file_name = "ga44_banner.jpg";
      }
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
    tick(start, end) {
      const now = new Date().getTime();
      const start_time = new Date(start).getTime();
      const end_time = new Date(end).getTime();

      if (this.show.fun_run) {
        const store_fun_run = this.$store.state.fun_run;
        const local_fun_run = this.fun_run;

        if (now >= end_time) {
          store_fun_run.has_started = true;
          store_fun_run.has_ended = true;
          local_fun_run.has_started = true;
          local_fun_run.has_ended = true;
        } else if (now >= start_time && now < end_time) {
          store_fun_run.has_started = true;
          store_fun_run.has_ended = false;
          local_fun_run.has_started = true;
          local_fun_run.has_ended = false;
        } else {
          store_fun_run.has_started = false;
          store_fun_run.has_ended = false;
          local_fun_run.has_started = false;
          local_fun_run.has_ended = false;
        }
      } else if (this.show.election) {
        const store_election = this.$store.state.election;
        const local_election = this.election;
        const schedules = local_election.schedules;

        const reg_start = schedules.registration_start
          ? new Date(schedules.registration_start).getTime()
          : null;

        const reg_end = schedules.registration_end
          ? new Date(schedules.registration_end).getTime()
          : null;

        const vote_start = schedules.voting_start
          ? new Date(schedules.voting_start).getTime()
          : null;

        const vote_end = schedules.voting_end
          ? new Date(schedules.voting_end).getTime()
          : null;

        if (reg_start && reg_end) {
          if (now >= reg_end) {
            schedules.registration_started = true;
            schedules.registration_ended = true;
          } else if (now >= reg_start) {
            schedules.registration_started = true;
            schedules.registration_ended = false;
          } else {
            schedules.registration_started = false;
            schedules.registration_ended = false;
          }
        }

        if (vote_start && vote_end) {
          if (now >= vote_end) {
            schedules.voting_started = true;
            schedules.voting_ended = true;
          } else if (now >= vote_start) {
            schedules.voting_started = true;
            schedules.voting_ended = false;
          } else {
            schedules.voting_started = false;
            schedules.voting_ended = false;
          }
        }

        store_election.schedules = { ...schedules };
      }

      setTimeout(() => this.tick(start, end), 1000);
    },
    loadFunRun() {
      this.$emit("showloader");
      FunRun.getSchedule()
        .then((response) => {
          const data = response.data.data;
          if (!Array.isArray(data) || !data.length) return;

          const event = data[0];
          const state = this.$store.state.fun_run;
          Object.assign(state, event);
          // this.fun_run = { ...state };
          Object.keys(state).forEach((key) => {
            this.fun_run[key] = state[key];
          });
          this.tick(state.registration_start, state.registration_end);
        })
        .catch((error) => this.$emit("error", error))
        .finally(() => this.$emit("hideloader"));
    },
    loadElection() {
      this.$emit("showloader");
      GA.getCurrentElection()
        .then((response) => {
          if (response.status === 200) {
            const data = response.data.data;
            const schedules = data.schedules || {};

            this.$store.state.ga.code = data.code;
            this.$store.state.ga.title = data.title;
            this.$store.state.ga.date = data.date;

            this.$store.state.ga.registration.start_date =
              schedules.registration_start;
            this.$store.state.ga.registration.started =
              schedules.registration_started ?? false;
            this.$store.state.ga.registration.end_date =
              schedules.registration_end;
            this.$store.state.ga.registration.ended =
              schedules.registration_ended ?? false;

            this.$store.state.ga.voting.start_date = schedules.voting_start;
            this.$store.state.ga.voting.started =
              schedules.voting_started ?? false;
            this.$store.state.ga.voting.end_date = schedules.voting_end;
            this.$store.state.ga.voting.ended = schedules.voting_ended ?? false;

            this.election.code = data.code;
            this.election.title = data.title;
            this.election.date = data.date;

            this.election.schedules.registration_start =
              schedules.registration_start;
            this.election.schedules.registration_started =
              schedules.registration_started ?? false;
            this.election.schedules.registration_end =
              schedules.registration_end;
            this.election.schedules.registration_ended =
              schedules.registration_ended ?? false;

            this.election.schedules.voting_start = schedules.voting_start;
            this.election.schedules.voting_started =
              schedules.voting_started ?? false;
            this.election.schedules.voting_end = schedules.voting_end;
            this.election.schedules.voting_ended =
              schedules.voting_ended ?? false;

            this.loadCandidates();
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
    loadCandidates() {
      this.$emit("showloader");
      GA.getAllCandidates(this.election.code, this.$store.state.info.hash)
        .then((response) => {
          if (response.status === 200) {
            const { candidates } = response.data.data;
            this.$store.state.ga.candidates = candidates;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => this.$emit("hideloader"));
    },
    register() {
      this.$emit("showloader");
      GA.register(this.election.code, this.$store.state.info.hash)
        .then((response) => {
          if (response.status === 200) {
            this.$emit("success", response.data.data.message);
            this.$store.state.ga.user.has_registered = true;
            this.election.user.has_registered = true;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => this.$emit("hideloader"));
    },
  },
};
</script>

<style scoped>
.line-container {
  width: 100%;
  text-align: center;
  margin: 20px 0;
}

.line-container hr {
  border: 0;
  height: 1px;
  background-color: rgba(51, 51, 51, 0.3);
  width: 100%;
}
</style>
